import Typography from '@mui/material/Typography';
import { FlexBox } from '../layout';
import BaseDialog from '../dialogs/BaseDialog';

interface SMSOptInConsentModalProps {
  open: boolean;
  onClose: (accepted: boolean) => void;
}

const SMSOptInConsentModal: React.FC<SMSOptInConsentModalProps> = ({
  open,
  onClose,
}) => {
  const renderSection = (title: string | null, content: string[]) => (
    <FlexBox flexDirection={'column'}>
      {title && <Typography variant="caption">{title}</Typography>}

      <Typography variant="body2">{content.join(' ')}</Typography>
    </FlexBox>
  );

  return (
    <BaseDialog
      open={open}
      onClose={() => onClose(false)}
      title="SMS Opt-In Terms of Service"
      footerAction={{
        left: {
          children: 'Ok',
          onClick: () => onClose(true),
          color: 'softGold',
        },
      }}
    >
      <FlexBox flexDirection="column" gap={2}>
        {renderSection(null, [
          'By enabling SMS messaging, you authorize Airship to send SMS text',
          'messages directly to you with updates and notifications generated',
          'through the Airship platform. These messages may include, but are not',
          'limited to, appointment reminders, alerts when a homeowner has viewed',
          'a shared proposal, notifications when a proposal has been won or',
          'updated, and other operational or business-related communications.',
        ])}

        {renderSection('Message & Data Rates:', [
          'Standard messaging and data rates may apply for receiving SMS',
          'messages. You should check with your mobile carrier for specific',
          'rate information.',
        ])}

        {renderSection('Opt-Out:', [
          'You may opt out of receiving SMS notifications at any time by replying',
          'STOP to any Airship-generated message.',
        ])}

        {renderSection('Privacy & Compliance:', [
          'All SMS messages sent through Airship comply with TCPA (Telephone',
          'Consumer Protection Act) and other applicable regulations. Your phone',
          'number and related data are handled in accordance with our Privacy Policy and will not be shared with third parties.',
        ])}

        {renderSection('Your Responsibilities:', [
          'You are responsible for ensuring that the phone number you provide is',
          'accurate and that you have the authority to receive SMS communications',
          'at that number. You must also ensure any opt-out requests are honored',
          'promptly.',
        ])}
      </FlexBox>
    </BaseDialog>
  );
};

export default SMSOptInConsentModal;
